<template>
  <div class="price-container">
    <CurrencyNew
      :price="course.price"
      :priceUnderline="course.underlined_price"
      :isUnderlineLeft="false"
      priceTwo
    ></CurrencyNew>
    <div class="discount" v-if="course.is_show_discount == 1">
      {{ course.discount }}折优惠
    </div>
  </div>
</template>
<script>
export default {
  name: "CourseShowPrice",
  props: {
    course: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.price-container {
  display: flex;
  align-items: center;

  /deep/ {
    .price-wrap {
      justify-content: flex-start;

      .price {
        font-size: 26px;
        margin-right: 16px;

        .rmb-svg-new {
          font-size: 18px;
          margin-right: 4px;
        }

        .decimal {
          font-size: 18px !important;
        }
      }

      .price-underline {
        font-size: 16px;
        padding-bottom: 2px;

        .rmb-svg-new {
          display: flex;
        }
      }
    }
  }

  .price {
    height: 42px;
    font-size: 26px;
    font-weight: 600;
    color: #ff2d28;
    line-height: 44px;
    display: inline-block;
    display: flex;
    align-items: center;

    span {
      display: inline-block;
    }
  }

  &.free {
    bottom: 4px;

    .price {
      font-size: 24px;
    }
  }

  .discount {
    height: 24px;
    background: rgba(252, 236, 206, 1);
    border-radius: 3px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(118, 73, 2, 1);
    padding: 0 8px;
    line-height: 24px;
    position: relative;
    margin-left: 11px;

    &::before {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-right-color: rgba(252, 236, 206, 1);
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
